import React, { ReactElement } from 'react';
import GridItem from '../../components/grid-item/grid-item.component';
import FormatService from '../../services/format-service';
import useStylesHeaderSubmenuItem from './header-submenu-item.styles';

const HeaderSubmenuItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isActive,
    children,
  } = props;

  const { classes } = useStylesHeaderSubmenuItem();

  const activeClassName: string | undefined = isActive ? classes.headerSubmenuItemActive : undefined;

  return (
    <GridItem className={FormatService.formatClassNames(classes.headerSubmenuItem, activeClassName)}>
      {children}
    </GridItem>
  );
});

export default HeaderSubmenuItem;
